<script setup lang="ts">
import { VR } from "@/widgets";
import { computed } from "vue";
import KeyIcon from "~icons/bxs/key";
import type { RadiusAuthParam } from "../../common/types.common";
import { defineActions, defineState } from "../common";
import { Buttons } from "../icons";
import { FormInputCheckbox, FormInputText } from "../input";
import { FormMessage, FormPanel, FormTool } from "../internal";
import { type BaseProps, defaultProps } from "../props";

type ModelType = RadiusAuthParam;
interface PropsType extends BaseProps<ModelType> {
    toggleable?: boolean;
    placeholder?: {
        [K in keyof ModelType]: string;
    };
    settingsURI?: string;
}

const props = withDefaults(defineProps<PropsType>(), {
    ...defaultProps<ModelType>(),
    toggleable: false,
    value: undefined,
});

const model = defineModel<ModelType>({
    required: true,
});

const state = defineState({
    model: model,
    props: props,
    hasValue: () => {
        if (model.value.isActive) {
            return model.value.username !== undefined && model.value.password !== undefined;
        } else {
            return true;
        }
    },
});

const actions = defineActions(model, props, state);

const collapsed = computed(() => {
    if (props.toggleable) {
        return !model.value.isActive;
    } else {
        return false;
    }
});

// watch(
//     () => props.toggleable,
//     () => (model.value.isActive = props.toggleable === false),
//     { immediate: true },
// );
</script>

<template>
    <FormPanel :collapsed="collapsed" :param="props">
        <template #header>
            <span class="inline-flex flex-row items-center gap-3">
                <FormInputCheckbox
                    v-if="props.toggleable"
                    v-model="model.isActive"
                    class="ml-1"
                    :disabled="!state.editMode"
                    embedMode="inline"
                />
                <KeyIcon v-else class="ml-1" />
                <span class="font-semibold text-gray-600 inline-flex flex-row gap-2">
                    {{ props.label ?? "Autentikasi RADIUS" }}
                    <Buttons.BtnGenerate v-if="model.isActive && state.generatable" @click="actions.onGenerate" />
                </span>
            </span>
        </template>

        <template #icons>
            <span class="inline-flex flex-row gap-4">
                <FormTool :actions="actions" :param="props" :showUpdate="true" :state="state" />
                <VR.RouterLink
                    v-if="props.settingsURI !== undefined"
                    v-tooltip.left="'Pengaturan'"
                    class="flex items-center justify-center border border-gray-300 rounded-lg p-0.5 w-10.5 h-10.5 hover:bg-gray-200"
                    :to="props.settingsURI"
                >
                    <i class="pi pi-cog text-gray-600 text-xl!"></i>
                </VR.RouterLink>
            </span>
        </template>

        <div v-if="state.hasError" class="p-4">
            <FormMessage :state="state" />
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <FormInputText v-model="model.username" embedMode="embed" label="Nama Pengguna" :mode="state.nestMode" />
            <FormInputText v-model="model.password" embedMode="embed" label="Kata Sandi" :mode="state.nestMode" />
        </div>
    </FormPanel>
</template>
